<template>
    <USelectMenu
        size="lg"
        :model-value="filter.selected"
        @update:model-value="onUpdate($event)"
        :options="[
            { name: 'Used', value: 'used', dot: 'bg-orange-500' },
            { name: 'Valid', value: 'valid', dot: 'bg-green-500' },
            { name: 'Expired', value: 'expired', dot: 'bg-red-500' },
        ]"
    >
        <template #label>
            <template v-if="filter.selected">
                <span :class="[filter.selected.dot, 'inline-block size-1.5 flex-shrink-0 rounded-full']" aria-hidden="true" />
                <span class="truncate font-medium">{{ filter.selected.name }}</span>
            </template>
            <span v-else class="text-gray-400">Select...</span>
        </template>
        <template #option="{ option }">
            <span :class="[option.dot, 'inline-block size-1.5 mx-1 flex-shrink-0 rounded-full']" aria-hidden="true" />
            <span class="truncate">{{ option.name }}</span>
        </template>
    </USelectMenu>
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()

function onUpdate(event: any) {
    emit('update:filter', {
        ...props.filter,
        selected: event,
        value: event.value,
    })
}
</script>